import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "6273fRe5ShJL5qLX7AOXFE/", "EnumBase", undefined);

/**游戏 状态 */
export var E_GameState;
/**游戏玩法类型 */

(function (E_GameState) {
  E_GameState["PreBegin"] = "preBegin";
  E_GameState["Gaming"] = "gaming";
  E_GameState["Over"] = "over";
})(E_GameState || (E_GameState = {}));

export var E_GameMode;

(function (E_GameMode) {
  E_GameMode["Time"] = "time";
  E_GameMode["Survival"] = "survival";
  E_GameMode["Indiana"] = "indiana";
  E_GameMode["Guide"] = "guide";
})(E_GameMode || (E_GameMode = {}));

export var E_TimeShowType;
/**
 * 界面类型
 */

(function (E_TimeShowType) {
  E_TimeShowType[E_TimeShowType["HMS"] = 0] = "HMS";
  E_TimeShowType[E_TimeShowType["MS"] = 1] = "MS";
})(E_TimeShowType || (E_TimeShowType = {}));

export var E_MainLayerType;

(function (E_MainLayerType) {
  E_MainLayerType[E_MainLayerType["Hall"] = 1] = "Hall";
  E_MainLayerType[E_MainLayerType["Game"] = 2] = "Game";
  E_MainLayerType[E_MainLayerType["GameLoading"] = 3] = "GameLoading";
  E_MainLayerType[E_MainLayerType["GameRecod"] = 4] = "GameRecod";
  E_MainLayerType[E_MainLayerType["Result"] = 5] = "Result";
  E_MainLayerType[E_MainLayerType["Set"] = 6] = "Set";
  E_MainLayerType[E_MainLayerType["PreGain"] = 7] = "PreGain";
  E_MainLayerType[E_MainLayerType["Reborn"] = 8] = "Reborn";
  E_MainLayerType[E_MainLayerType["DanAlert"] = 9] = "DanAlert";
  E_MainLayerType[E_MainLayerType["Sign"] = 10] = "Sign";
  E_MainLayerType[E_MainLayerType["Achieve"] = 11] = "Achieve";
  E_MainLayerType[E_MainLayerType["Shop"] = 12] = "Shop";
  E_MainLayerType[E_MainLayerType["Gift"] = 13] = "Gift";
})(E_MainLayerType || (E_MainLayerType = {}));

export var E_AlertType;
/**
 * 角色的展示场景
 */

(function (E_AlertType) {
  E_AlertType[E_AlertType["RoleGainAlert"] = 0] = "RoleGainAlert";
  E_AlertType[E_AlertType["WeaponGainAlert"] = 1] = "WeaponGainAlert";
  E_AlertType[E_AlertType["DanUp"] = 2] = "DanUp";
})(E_AlertType || (E_AlertType = {}));

export var E_RoleUseScene;
/**
 * 节点相对界面的位置
 */

(function (E_RoleUseScene) {
  E_RoleUseScene[E_RoleUseScene["Show"] = 0] = "Show";
  E_RoleUseScene[E_RoleUseScene["Game"] = 1] = "Game";
})(E_RoleUseScene || (E_RoleUseScene = {}));

export var NodeInWindow_Pos;
/**
 * 分组 - 跟游戏配置中的 index 一一对应
 */

(function (NodeInWindow_Pos) {
  NodeInWindow_Pos["Top"] = "top";
  NodeInWindow_Pos["Bottom"] = "bottom";
  NodeInWindow_Pos["Left"] = "left";
  NodeInWindow_Pos["Right"] = "right";
})(NodeInWindow_Pos || (NodeInWindow_Pos = {}));

export var ColliderGroup;

(function (ColliderGroup) {
  ColliderGroup[ColliderGroup["LINE"] = 2] = "LINE";
  ColliderGroup[ColliderGroup["BALL"] = 4] = "BALL";
  ColliderGroup[ColliderGroup["COLLIDER"] = 8] = "COLLIDER";
  ColliderGroup[ColliderGroup["BARRIER"] = 16] = "BARRIER";
  ColliderGroup[ColliderGroup["PROP"] = 32] = "PROP";
})(ColliderGroup || (ColliderGroup = {}));

export var E_LayerGroup;
/**信息提示 */

(function (E_LayerGroup) {
  E_LayerGroup[E_LayerGroup["UI_Static"] = 1] = "UI_Static";
  E_LayerGroup[E_LayerGroup["BG"] = 2] = "BG";
  E_LayerGroup[E_LayerGroup["UI_2D"] = 33554432] = "UI_2D";
  E_LayerGroup[E_LayerGroup["DEFAULT"] = 1073741824] = "DEFAULT";
})(E_LayerGroup || (E_LayerGroup = {}));

export var E_MsgType;
/**
 * 预制体路径
 */

(function (E_MsgType) {
  E_MsgType[E_MsgType["Energy"] = 0] = "Energy";
  E_MsgType[E_MsgType["NoEnergy"] = 1] = "NoEnergy";
})(E_MsgType || (E_MsgType = {}));

export var E_ResPath;
/**
 * jsb - 数据类型
 */

(function (E_ResPath) {
  E_ResPath["Pfb_Root"] = "Prefabs/";
  E_ResPath["Tex_BallRoot"] = "Tex/Ball/";
  E_ResPath["Tex_LineShowRoot"] = "Tex/Line/";
  E_ResPath["Tex_ChapterIcon"] = "Tex/ChapterIcon/";
})(E_ResPath || (E_ResPath = {}));

export var E_JSB;
/**
 * 广告播放入口
 */

(function (E_JSB) {
  E_JSB["S"] = "Ljava/lang/ String;";
  E_JSB["I"] = "I";
  E_JSB["F"] = "F";
  E_JSB["B"] = "Z";
  E_JSB["V"] = "V";
})(E_JSB || (E_JSB = {}));

export var E_AdType;
/**
 * 广告平台
 */

(function (E_AdType) {
  E_AdType[E_AdType["None"] = 0] = "None";
  E_AdType[E_AdType["ShopBall"] = 1] = "ShopBall";
  E_AdType[E_AdType["ShopLine"] = 2] = "ShopLine";
  E_AdType[E_AdType["Magnetism"] = 3] = "Magnetism";
  E_AdType[E_AdType["Acceleration"] = 4] = "Acceleration";
  E_AdType[E_AdType["Gift"] = 5] = "Gift";
  E_AdType[E_AdType["Reborn"] = 6] = "Reborn";
  E_AdType[E_AdType["Win"] = 7] = "Win";
})(E_AdType || (E_AdType = {}));

export var E_PlatformType;
/**
 * 游戏中的url
 */

(function (E_PlatformType) {
  E_PlatformType[E_PlatformType["Normal"] = 0] = "Normal";
  E_PlatformType[E_PlatformType["Cocos"] = 1] = "Cocos";
  E_PlatformType[E_PlatformType["Dob5"] = 2] = "Dob5";
  E_PlatformType[E_PlatformType["ChuanYin"] = 3] = "ChuanYin";
  E_PlatformType[E_PlatformType["XiaoXiong"] = 4] = "XiaoXiong";
  E_PlatformType[E_PlatformType["Cocos_h5"] = 5] = "Cocos_h5";
  E_PlatformType[E_PlatformType["Aunit"] = 6] = "Aunit";
  E_PlatformType[E_PlatformType["TT"] = 7] = "TT";
  E_PlatformType[E_PlatformType["GoogleADM"] = 8] = "GoogleADM";
  E_PlatformType[E_PlatformType["Ad4399"] = 9] = "Ad4399";
  E_PlatformType[E_PlatformType["GameDistributions"] = 10] = "GameDistributions";
  E_PlatformType[E_PlatformType["GameMonetize"] = 11] = "GameMonetize";
  E_PlatformType[E_PlatformType["XiaoMi"] = 12] = "XiaoMi";
})(E_PlatformType || (E_PlatformType = {}));

export var E_GameUrl;

(function (E_GameUrl) {})(E_GameUrl || (E_GameUrl = {}));

export var E_EasingType;
/**
 * 广告事件类型
 */

(function (E_EasingType) {
  E_EasingType[E_EasingType["None"] = 0] = "None";
  E_EasingType[E_EasingType["quadIn"] = 1] = "quadIn";
  E_EasingType[E_EasingType["quadOut"] = 2] = "quadOut";
  E_EasingType[E_EasingType["quadInOut"] = 3] = "quadInOut";
  E_EasingType[E_EasingType["cubicIn"] = 4] = "cubicIn";
  E_EasingType[E_EasingType["cubicOut"] = 5] = "cubicOut";
  E_EasingType[E_EasingType["cubicInOut"] = 6] = "cubicInOut";
  E_EasingType[E_EasingType["quartIn"] = 7] = "quartIn";
  E_EasingType[E_EasingType["quartOut"] = 8] = "quartOut";
  E_EasingType[E_EasingType["quartInOut"] = 9] = "quartInOut";
  E_EasingType[E_EasingType["quintIn"] = 10] = "quintIn";
  E_EasingType[E_EasingType["quintOut"] = 11] = "quintOut";
  E_EasingType[E_EasingType["quintInOut"] = 12] = "quintInOut";
  E_EasingType[E_EasingType["sineIn"] = 13] = "sineIn";
  E_EasingType[E_EasingType["sineOut"] = 14] = "sineOut";
  E_EasingType[E_EasingType["sineInOut"] = 15] = "sineInOut";
  E_EasingType[E_EasingType["expoIn"] = 16] = "expoIn";
  E_EasingType[E_EasingType["expoOut"] = 17] = "expoOut";
  E_EasingType[E_EasingType["expoInOut"] = 18] = "expoInOut";
  E_EasingType[E_EasingType["circIn"] = 19] = "circIn";
  E_EasingType[E_EasingType["circOut"] = 20] = "circOut";
  E_EasingType[E_EasingType["circInOut"] = 21] = "circInOut";
  E_EasingType[E_EasingType["elasticIn"] = 22] = "elasticIn";
  E_EasingType[E_EasingType["elasticOut"] = 23] = "elasticOut";
  E_EasingType[E_EasingType["elasticInOut"] = 24] = "elasticInOut";
  E_EasingType[E_EasingType["backIn"] = 25] = "backIn";
  E_EasingType[E_EasingType["backOut"] = 26] = "backOut";
  E_EasingType[E_EasingType["backInOut"] = 27] = "backInOut";
  E_EasingType[E_EasingType["bounceIn"] = 28] = "bounceIn";
  E_EasingType[E_EasingType["bounceOut"] = 29] = "bounceOut";
  E_EasingType[E_EasingType["bounceInOut"] = 30] = "bounceInOut";
})(E_EasingType || (E_EasingType = {}));

export var E_ADEventType;
/**
 * 游戏事件类型
 */

(function (E_ADEventType) {
  E_ADEventType["sdk_init"] = "sdk_init";
  E_ADEventType["msgTip"] = "msgTip";
  E_ADEventType["log"] = "log";
  E_ADEventType["banner_show"] = "banner_show";
  E_ADEventType["banner_hide"] = "banner_hide";
  E_ADEventType["banner_loadOver"] = "banner_load_over";
  E_ADEventType["banner_loadFail"] = "banner_loadFail";
  E_ADEventType["interstitial_show"] = "interstitial_show";
  E_ADEventType["interstitial_loadFail"] = "interstitial_loadFail";
  E_ADEventType["interstitial_loadOver"] = "interstitial_loadOver";
  E_ADEventType["interstitial_showOver"] = "interstitial_Over";
  E_ADEventType["interstitial_showFail"] = "interstitial_showFail";
  E_ADEventType["interstitial_showFail_tip"] = "interstitial_showFail_tip";
  E_ADEventType["video_show"] = "video_show";
  E_ADEventType["video_close"] = "video_close";
  E_ADEventType["video_loadFail"] = "video_loadFail";
  E_ADEventType["video_loadOver"] = "video_loadOver";
  E_ADEventType["video_showOver"] = "video_showOver";
  E_ADEventType["video_showFail"] = "video_showFail";
  E_ADEventType["video_showFail_tip"] = "video_playFail_tip";
})(E_ADEventType || (E_ADEventType = {}));

export var E_EventType;

(function (E_EventType) {
  E_EventType["Log_Show"] = "Log_Show";
  E_EventType["Tip_Show"] = "tip_show";
  E_EventType["Msg_Tip"] = "msg_tip";
  E_EventType["Score_Fly"] = "word_fly";
  E_EventType["Fit_Node"] = "fit_node";
  E_EventType["Res_Load"] = "res_load";
  E_EventType["Res_LoadOver"] = "res_load_over";
  E_EventType["Layer_Switch"] = "layerSwitch";
  E_EventType["Alert_Show"] = "alertShow";
  E_EventType["Tip_FlyWords"] = "tipFlyWords";
  E_EventType["Coin_Change"] = "coinChange";
  E_EventType["Ball_Change"] = "ballChange";
  E_EventType["Ball_Die"] = "ballDIe";
  E_EventType["Game_Begin"] = "gameBegin";
  E_EventType["Game_End"] = "gameEnd";
  E_EventType["Game_Reset"] = "gameReset";
  E_EventType["Line_Reset"] = "lineReset";
  E_EventType["Lv_Up"] = "lvUp";
  E_EventType["Touch_BeginSelf"] = "touchBeginSelf";
  E_EventType["Touch_EndSlef"] = "touchEndSelf";
  E_EventType["Touch_MoveSelf"] = "touchMoveSelf";
  E_EventType["Tip_Msg"] = "tipMsg";
  E_EventType["Tip_Shop"] = "tipShop";
  E_EventType["Reborn"] = "reborn";
})(E_EventType || (E_EventType = {}));

export var E_RedDotType;

(function (E_RedDotType) {
  E_RedDotType[E_RedDotType["Skin"] = 0] = "Skin";
  E_RedDotType[E_RedDotType["Weapon"] = 1] = "Weapon";
  E_RedDotType[E_RedDotType["Sign"] = 2] = "Sign";
  E_RedDotType[E_RedDotType["Achieve"] = 3] = "Achieve";
  E_RedDotType[E_RedDotType["Dan"] = 4] = "Dan";
})(E_RedDotType || (E_RedDotType = {}));

_cclegacy._RF.pop();